import Swal from 'sweetalert2'

const Alert = (texto, sucesso = true, info = false, isHtml = false) => {
    if (!isHtml)
        Swal.fire({
            title: sucesso ? "" : "Atenção",
            text: texto,
            icon: info ? "info" : sucesso ? "success" : "error",
        });
    else
        Swal.fire({
            title: sucesso ? "" : "Atenção",
            html: texto,
            icon: info ? "info" : sucesso ? "success" : "error",
        });
};

const MENSAGEM_ERRO_PADRAO = 'Houve um erro na solicitação! Por favor tente novamente mais tarde.';

// Extrai a mensagem que o backend devolveu; só usa o texto padrão quando não vier nada
const MensagemErro = (erro, padrao = MENSAGEM_ERRO_PADRAO) => {
    if (typeof erro === 'string' && erro.trim()) return erro;

    const data = erro?.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    if (data?.mensagem) return data.mensagem;
    if (data?.message) return data.message;
    if (data?.error) return data.error;
    if (data?.errors) return Object.values(data.errors).flat().join('\n');
    if (data?.title) return data.title;

    if (erro?.response?.status === 403) return 'Você não tem permissão para realizar esta ação.';
    if (erro && !erro.response && erro.message) return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.';

    return padrao;
};

const AlertErro = (erro, padrao) => Alert(MensagemErro(erro, padrao), false);

const Pergunta = (texto) => {
    return new Promise((resolve) => {
        Swal.fire({
            title: texto,
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SIM",
            cancelButtonText: "NÃO"
        }).then((result) => {
            resolve(result.isConfirmed);
        });
    });
};

const PerguntaInput = (texto) => {
    return new Promise((resolve) => {
        Swal.fire({
            title: texto,
            input: 'text',
            inputAttributes: {
                required: 'true'
            },
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar',
            preConfirm: (input) => {
                if (!input) {
                    Swal.showValidationMessage('Você precisa informar o motivo')
                }
                return input;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                resolve(result.value);
            } else {
                resolve(null);
            }
        });
    });
};


export { Alert, AlertErro, MensagemErro, Pergunta, PerguntaInput };